import PropTypes from 'prop-types';
import Device from './Device';

import css from './device-list.module.scss';

const DeviceList = ({ devices, onDeleteDevice }) => (
  <div data-testid="deviceList" className={css.deviceList}>
    {devices.map((device, index) => {
      const elements = [
        <Device
          key={`device-${index}`}
          dataTestId={`device-${index}`}
          device={device}
          onDeleteDevice={onDeleteDevice}
        />,
      ];

      // Only output if not the last device in the list
      if (index + 1 !== devices.length) {
        elements.push(<hr key={`divider-${index}`} className={css.divider} />);
      }

      return elements;
    })}
  </div>
);

DeviceList.propTypes = {
  devices: PropTypes.array.isRequired,
  onDeleteDevice: PropTypes.func.isRequired,
};

export default DeviceList;
